import NFA from 'shared/helpers/analytics/NFAnalytics';

export const canShowPDPMeasurements = (config?: string) => config === 'true';

interface SizeTrackingData {
  selectedSizesList: string[];
  selectedSize: string;
}
export const trackSizeSelection = (sizeTrackingData: SizeTrackingData) => {
  NFA.track({
    event: 'product_size_clicked',
    data: {
      ...sizeTrackingData,
      sizeSelectionCount: sizeTrackingData?.selectedSizesList?.length,
    },
  });
};
